/** Match server `utils/productUrlId.js` — client fallback when API omits urlId. */
export function slugifyProductName(name) {
  return String(name || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getProductUrlSlug(product) {
  if (!product || typeof product !== 'object') return '';
  const explicit = product.urlId || product.url_id || product.metadata?.urlId;
  if (explicit && String(explicit).trim()) return String(explicit).trim();
  return slugifyProductName(product.name);
}
